export default "__VITE_ASSET__$zuzcsAo__"